var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#FFF"},[React.createElement("path",{"d":"M26.298 26.299h9.297c1.208 0 2.196-.988 2.196-2.197 0-1.208-.988-2.197-2.196-2.197h-9.297V12.61c0-1.21-.988-2.198-2.196-2.198-1.208 0-2.198.989-2.198 2.198v9.295H12.61c-1.208 0-2.197.989-2.197 2.197 0 1.209.99 2.197 2.197 2.197h9.295v9.296c0 1.208.99 2.197 2.198 2.197s2.197-.99 2.196-2.197v-9.296z","key":0}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M47.703 24.102c0 13.034-10.566 23.603-23.602 23.603-13.034 0-23.6-10.569-23.6-23.603S11.066.5 24.1.5c13.037 0 23.602 10.568 23.602 23.602z","key":1})])));
}

Add.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49"};

module.exports = Add;

Add.default = Add;
